import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 * Fix: allow "Read more" anchor link clicks to navigate normally
 * without being intercepted by the card's click handler.
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback?.();
    this.addEventListener('click', this._handleCardClick.bind(this), true);
  }

  _handleCardClick(event) {
    const anchor = event.target.closest('a');
    if (anchor) {
      // Let anchor clicks pass through naturally
      event.stopPropagation();
      return;
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
